import { AccountService } from 'common/services/account.service';
import AccountStore from 'common/stores/accounts/account.store';
import { captureError, OpenRealAccountError } from 'common/utils/error.util';
import i18n from 'i18n';
import { action, computed, observable, makeObservable } from 'mobx';
import { Notifier } from '../common/services/notification.service';

class ManageAccount {
  @observable servers = [];

  constructor() {
    makeObservable(this);
  }

  @computed get isAvailableCreateAccount() {
    const hasPendingAccounts = AccountStore.pendingAccounts.length > 0;
    return !hasPendingAccounts;
  }

  @action
  createAccount(params = {}) {
    const data = JSON.stringify(params);
    return AccountService.createAccount(data).catch((error) => {
      Notifier.error(i18n.t('common.notification.account_created.error'));
      if (params.account_type?.includes('real') || params.is_trading)
        captureError(new OpenRealAccountError(error));
      throw error;
    });
  }
}

const ManageAccountStore = new ManageAccount();

export default ManageAccountStore;
